/**
 * @generated SignedSource<<d5f6bb6cb8afe74c52384054a3599493>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteDiscountCodeInput = {
  clientMutationId?: string | null;
  discountCodeId: string;
};
export type discountCodeDeleteButton_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteDiscountCodeInput;
};
export type discountCodeDeleteButton_DeleteMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly deleteDiscountCode: {
        readonly clientMutationId: string | null;
        readonly deletedIds: ReadonlyArray<string>;
      } | null;
    };
  };
};
export type discountCodeDeleteButton_DeleteMutation = {
  response: discountCodeDeleteButton_DeleteMutation$data;
  variables: discountCodeDeleteButton_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "discountCodeDeleteButton_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteDiscountCodePayload",
                "kind": "LinkedField",
                "name": "deleteDiscountCode",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "discountCodeDeleteButton_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteDiscountCodePayload",
                "kind": "LinkedField",
                "name": "deleteDiscountCode",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5225c486aa742c963f24ebecdce5a1be",
    "id": null,
    "metadata": {},
    "name": "discountCodeDeleteButton_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation discountCodeDeleteButton_DeleteMutation(\n  $input: DeleteDiscountCodeInput!\n) {\n  Admin {\n    Billing {\n      deleteDiscountCode(input: $input) {\n        deletedIds\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1f20dd74df42d2f3f9627f7e83f0717d";

export default node;
